/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCornerRightDown = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M3 3h14l-.001 14.656L19.761 15 21 16.192 16 21l-5-4.808L12.239 15l2.76 2.655L15 5H3z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCornerRightDown as CornerRightDown };
